export default __webpack_public_path__ + "static/media/linesMobile.deaaa87d.svg";